import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DEBUG_INFO_ENABLED } from 'app/app.constants';
import { SELF_SERVICE_ROUTES } from 'app/layouts/homepage';

@NgModule({
    imports: [
        RouterModule.forRoot(
            [
                // {
                //     path: 'admin',
                //     loadChildren: './admin/admin.module#NewssoappAdminModule'
                // },
                ...SELF_SERVICE_ROUTES
            ],
            { useHash: true, enableTracing: DEBUG_INFO_ENABLED }
        )
    ],
    exports: [RouterModule]
})
export class NewssoappAppRoutingModule {}
